<template>
  <template-personal
    :pathName="pathName"
    :hasFinalTaxType="hasFinalTaxType"
    :fact="fact"
  >
    <div slot="to-do">
      <div class="contents"></div>
    </div>
  </template-personal>
</template>

<script>
export default {
  name: "PersonalRegisteredWithVat",
  props: ["hasFinalTaxType"],
  data() {
    return {
      pathName: "personal_registered_with_vat",
      fact: [
        "คุณจะมีค่าใช้จ่ายเพิ่มเติมที่ตามมาหลังจด VAT คือ ค่าใช้จ่ายในการจัดทำและนำส่ง VAT แต่ละเดือน",
        "การจด VAT ช่วยให้คุณมีหลักฐานในการขอเครดิตจากธนาคารในกรณีที่คุณต้องการเงินทุนเพื่อขยายกิจการในอนาคต",
      ],
    };
  },
};
</script>

<style scoped></style>
